import { AccountType } from '~/models/operator';

export function isSystemManager(operator: Operator | null) {
  return operator?.account_type === AccountType.SYSTEM_MANAGER;
}

export function isOrganizationManagerOrAbove(operator: Operator | null) {
  return (
    operator?.account_type === AccountType.SYSTEM_MANAGER || operator?.account_type === AccountType.ORGANIZATION_MANAGER
  );
}

export function isShopManagerOrAbove(operator: Operator | null) {
  return (
    operator?.account_type === AccountType.SYSTEM_MANAGER ||
    operator?.account_type === AccountType.ORGANIZATION_MANAGER ||
    operator?.account_type === AccountType.SHOP_MANAGER
  );
}
